import React from "react"
import ReactModal from "react-modal"
import PropTypes from "prop-types"
import closeIcon from "../assets/close-icon.svg"

import styles from "./Modal.module.scss"

const Modal = ({ isOpen, onClose, children, allowClose = true }) => {
  const handleRequestClose = () => {
    if (allowClose) {
      onClose()
    }
  }

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      className={styles.modalContainer}
      overlayClassName={styles.modalOverlay}
      shouldCloseOnOverlayClick={allowClose}
      shouldCloseOnEsc={allowClose}
    >
      {allowClose && (
        <button className={styles.closeButton} onClick={onClose} type="button">
          <img src={closeIcon} alt="close" />
        </button>
      )}
      {children}
    </ReactModal>
  )
}

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  allowClose: PropTypes.bool
}

export default Modal
